export const SWITCHING_TREE_ENDPOINT = "/customer-behavior/switching/tree"
export const SWITCHING_BENCHMARK_ENDPOINT =
	"/customer-behavior/switching/breakdown"
export const SWITCHING_SANKEY_ENDPOINT = "/customer-behavior/switching/sankey"
export const PERIOD_KEY = "SWITCHING_TREE_SELECTED_PERIOD"
export const ERROR_CODE_TIMEOUT = "PH-0003"
export const STATUS_CODE_TIMEOUT = "408"
export const METRICS_ERROR = "PH-0001"
export const STATUS_CODE = "500"
export const DEFAULT_NAME_FATHER_NODE = "Total"
export const TYPE_SELECT_PERIOD = "period"
export const LABEL_DEFAULT_FILTER_SELECT = ["Todas", "All"]
export const DEFAULT_OPTION_TITLE_FATHER_NODE = 0

export enum BROWSER {
	CHROME = "Chrome",
	SAFARI = "Safari",
}

export enum FiltersParameters {
	DEPARTMENTS = "departments",
	CATEGORIES = "categories",
	SUBCATEGORIES = "subcategories",
	FINELINE = "fineline",
}

export const SWITCHING_BENCHMARK_BREAKDOWN_MOCK = {
	switchingBreakdownMetrics: {
		levelName: "subcategory",
		details: [
			{
				id: "12947",
				name: "SALCHICHAS",
				profits: 9521822350.51,
				losses: 7682291439.78,
				difference: -2345695,
			},
			{
				id: "8477",
				name: "ALMUERZO DE CARNE - CECINAS",
				profits: 9521822350.51,
				losses: 7682291439.78,
				difference: 2399999,
			},
			{
				id: "12946",
				name: "PARRILLEROS",
				profits: 9521822350.51,
				losses: 7682291439.78,
				difference: 0,
			},
		],
	},
}
